import Botao from "../../Botao";
import { useNavigate } from "react-router-dom";

const SectionProcessos = () => {
    const navigate = useNavigate();

    return (
        <section>
            <div style={{display: 'flex', justifyContent: 'space-around', width: '500px'}}>
                <Botao text={'Novo Processo'} onClick={() => navigate('/novoProcesso')} />
                <Botao text={'Continuar Processo'} onClick={() => navigate('/continuarProcessos')} />
            </div>
        </section>
    )
}

export default SectionProcessos;